export interface OrderValue {
  orderBy: string;
  orderDirection: EOrderDirection;
}

export enum EOrderDirection {
  Descending = 'desc',
  Ascending = 'asc'
}
